<div class="compare-panes">

    <div class="compare-pane" *ngFor="let file of ResolvedFiles; let i = index">

        <span class="compare-pane-label" [title]="file.name">{{file.name}}</span>

        <ng-container [ngSwitch]="file.format">

            <ng-container *ngSwitchCase="'pdf'">

                <object [data]="file.url|security:'resourceUrl'" type="application/pdf" width="100%">
                    <source [src]="file.url|security:'resourceUrl'" type="application/pdf" />
                    <p>O seu navegador não suporta PDFs. <a [href]="file.url">Clique aqui para abrir.</a></p>
                </object>

            </ng-container>

            <ng-container *ngSwitchDefault>

                <div class="image-wrapper">
                    <img *ngIf="file.url" [src]="file.url"
                        [style.transform]="'translate(' + ViewerState[i].translateX + 'px,' + ViewerState[i].translateY + 'px) ' + 'scale(' + ViewerState[i].zoom + ') ' +  'rotate(' + ViewerState[i].rotation + 'deg)'"
                        (mousedown)="StartDrag(i, $event)" (mousemove)="OnDrag(i, $event)" (mouseup)="EndDrag(i)"
                        (mouseleave)="EndDrag(i)" (wheel)="OnWheel(i, $event)" />
                </div>

                <div class="pane-controls">

                    <ion-button fill="clear" (click)="ZoomOut(i)">
                        <ion-icon name="remove-outline" slot="icon-only"></ion-icon>
                    </ion-button>

                    <ion-button fill="clear" (click)="ZoomIn(i)">
                        <ion-icon name="add-outline" slot="icon-only"></ion-icon>
                    </ion-button>

                    <ion-button fill="clear" (click)="Rotate(i, -90)">
                        <ion-icon name="refresh-outline" slot="icon-only" style="transform: scaleX(-1)"></ion-icon>
                    </ion-button>

                    <ion-button fill="clear" (click)="Reset(i)">
                        <ion-icon name="contract-outline" slot="icon-only"></ion-icon>
                    </ion-button>

                    <ion-button fill="clear" (click)="Rotate(i, 90)">
                        <ion-icon name="refresh-outline" slot="icon-only"></ion-icon>
                    </ion-button>

                </div>

            </ng-container>
        </ng-container>

    </div>

</div>
